import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar } from '@mui/material';
import { hideSnackBar, showSnackBar } from './CustomComponentsSlice';
import { maroon, green, red } from '../../assets/colors';

const CustomSnackBar = () => {

  const dispatch = useDispatch()
  const {open, message, severity} = useSelector(state => state.snackBar)

  const handleClose = () => {
    dispatch(hideSnackBar())
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      message={message}
      onClose={() => handleClose()}
      ContentProps={{sx: {
        backgroundColor: severity === 'success' ? green : (severity === 'error' || severity === 'fail' ? red : maroon)
      }}}
    ></Snackbar>
  )
}

export default CustomSnackBar
